import moment from "moment"
import { GroupMessageProps } from "../../../store/types/soc_svc"

export const message_getUniqueDates = (gm:GroupMessageProps[]) => {
    let dates:any[] = []
    gm.map((m,i) => {
        let formatted_date = moment(m.create_datetime).format('MMM DD YYYY')
        let date = dates.find(d => d.date === formatted_date)
        if(!date){
            dates = dates.concat({date: formatted_date, message_index: i})
        }
    })
    return dates
}



export const message_getEmptyMessage = ():GroupMessageProps => {
    return {
        group_message_id: '',
        group_id: '',
        player_id: '',
        message: '',
        create_datetime:'',
        last_update_datetime:'',
        message_images:[],
        message_orders:[],
        message_urls:[],
        message_videos:[],
        url_metadata:[],
        status:'published',
        visibility_status:true,
        formatted_body: undefined
    }
}